import { Input, Stack, Switch, Text } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { FormattedMessage, useIntl } from 'react-intl'
import { LabelWithHint } from '@/components/ui-shared/LabelWithHint/LabelWithHint'
import { MultilineTextListInput } from '@/components/ui-shared/MultilineTextListInput/MultilineTextListInput'
import { FormValues } from '../DeploymentSettings'
import { SettingsCard } from '../SettingsCard'

type OcrSettingsProps = {
  form: UseFormReturnType<FormValues>
}

export const OcrSettings = ({ form }: OcrSettingsProps) => {
  const intl = useIntl()

  return (
    <SettingsCard
      title={<FormattedMessage id="deployments.ocrSettings.title" />}
      contentMaxWidth={480}
    >
      <Stack gap="xl">
        <Text size="xs">
          <FormattedMessage id="deployments.ocrSettings.description" />
        </Text>

        <MultilineTextListInput
          {...form.getInputProps('ocrSettings.whitelist')}
          label={
            <LabelWithHint
              label={
                <FormattedMessage id="deployments.ocrSettings.whitelist.input.label" />
              }
              hint={
                <FormattedMessage id="deployments.ocrSettings.whitelist.input.description" />
              }
            />
          }
          placeholder={intl.formatMessage({
            id: 'deployments.ocrSettings.input.placeholder'
          })}
        />

        <MultilineTextListInput
          {...form.getInputProps('ocrSettings.blacklist')}
          label={
            <LabelWithHint
              label={
                <FormattedMessage id="deployments.ocrSettings.blacklist.input.label" />
              }
              hint={
                <FormattedMessage id="deployments.ocrSettings.blacklist.input.description" />
              }
            />
          }
          placeholder={intl.formatMessage({
            id: 'deployments.ocrSettings.input.placeholder'
          })}
        />

        <Input.Wrapper
          description={
            <FormattedMessage id="deployments.ocrSettings.detector.input.description" />
          }
          inputWrapperOrder={['label', 'input', 'description']}
        >
          <Switch
            mb="xs"
            {...form.getInputProps('ocrSettings.detector', {
              type: 'checkbox'
            })}
            label={
              <FormattedMessage id="deployments.ocrSettings.detector.input.label" />
            }
          />
        </Input.Wrapper>
      </Stack>
    </SettingsCard>
  )
}
